import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Navigation from './Navigation';

export default function PrivateRouteWithNavbar({ component: Component, ...rest }) {
    const { currentUser } = useAuth();

    return (
        <Route 
            {...rest}
            render={props => {
                return currentUser ? <><Navigation/><Component {...props} /></> : <Redirect to="/login" />
            }}>

        </Route>
    )
}